// extracted by mini-css-extract-plugin
export default {"container":"StartActivity_container__iVuPU","title":"StartActivity_title__ljp69","infosContainer":"StartActivity_infosContainer__S+oiE","chevron":"StartActivity_chevron__1kT8M"};